import React from 'react'
import s from '../images/s-new.jpg'
// import { Link } from 'react-router-dom'

const About = () => {
  return (
    <div id='about'>
      <div className='w-screen222 py-15 flex justify-center items-center bg-transparent'>
        <div className='bg-white shadow-xl shadow-blue-100 bg-opacity-90 flex flex-col justify-center items-center mx-1 w-full sm:mx-15 md:w-3/5 lg:w-3/6 rounded p-4 md:p-10 lg:p-15 xl:p-20'>
          <div className='text-xl font-medium text-blue-500 mb-3'>About Us</div>
          <div className='flex flex-row w-full justify-between flex-nowrap'>
          <img className='h-24' src={s} alt='s' />
          <div className='flex flex-col items-center justify-center'>
            <div className='text-3xl text-gray-800 font-bold mb-0 pb-0'>Wirelessstore</div>
            <div className='text-3xl text-gray-800 font-bold mb-0 pb-0'>Wirelessstore.com</div>
            <div className='text-3xl text-gray-800 font-bold mb-0 pb-0'>Wirelessstore.ca</div>
            <div className='text-3xl text-gray-800 font-bold mb-5'>Yourwirelessstore.com</div>
          </div>
          <img className='h-24' src={s} alt='s' />
          </div>
          <div className='text-xl mb-4 leading-10'>
            We offer a huge catalog of the latest and greatest gadgets, along with free shipping on
            every order from our online store.
          </div>
          <p className='text-center font-light text-base leading-8'>
            WirelessStore.com oversees some of the largest online retail stores specializing in high-quality, brand-name wireless merchandise at discount prices. We continue to work and partner with reputable companies globally to find the best electronic deals and bring to our customers the best online shopping experience. We are the #1 most popular and have most authoritative online presence providing value-added services with the latest in wireless products and trends. Our expert researchers and marketing specialists work day and night to bring you the leading-edge products with the best prices possible.
          </p>
        </div>
      </div>
    </div>
  )
}

export default About
